import { Input, Button, Space } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  size?: string
  style?: React.CSSProperties
  passwordLength?: number | null
}

const InputPassword = ({ value, onChange, passwordLength  }: IProps) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState<string>(value || "");
  
  const generatePassword = (length: number) => {
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const specialChars = "!#$%&?\".";

    const getRandomChar = (charset: string) => charset.charAt(Math.floor(Math.random() * charset.length));
    let generatedPassword = getRandomChar(lowercase) + getRandomChar(uppercase) + getRandomChar(numbers) + getRandomChar(specialChars);

    const allChars = lowercase + uppercase + numbers + specialChars;
    for (let i = generatedPassword.length; i < length; i++) {
      generatedPassword += getRandomChar(allChars);
    }

    const shuffledPassword = shuffleString(generatedPassword);
    setPassword(shuffledPassword);
    if (onChange) onChange({ target: { value: shuffledPassword } } as React.ChangeEvent<HTMLInputElement>);
  };

  const shuffleString = (str: string) => str.split('').sort(() => 0.5 - Math.random()).join('');
  return (
    <>
    <Space>
      <Input.Password
        style={{minWidth:240}}
        value={password}
        showCount
        maxLength={passwordLength || 8}
        size="middle"
        onChange={(e) => {
          setPassword(e.target.value);
          if (onChange) onChange(e); 
        }}
        placeholder={t('auth.password')}
      />
      <Button type="text" onClick={() => generatePassword(passwordLength || 8)}>{t('auth.generate_password')}</Button>
      </Space>
    </>
  );
};

export default InputPassword;